import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import ProductOfferingPrice from './product-offering-price';
import ProductOfferingPriceDetail from './product-offering-price-detail';
import ProductOfferingPriceUpdate from './product-offering-price-update';
import ProductOfferingPriceDeleteDialog from './product-offering-price-delete-dialog';

const ProductOfferingPriceRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<ProductOfferingPrice />} />
    <Route path="new" element={<ProductOfferingPriceUpdate />} />
    <Route path=":id">
      <Route index element={<ProductOfferingPriceDetail />} />
      <Route path="edit" element={<ProductOfferingPriceUpdate />} />
      <Route path="delete" element={<ProductOfferingPriceDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default ProductOfferingPriceRoutes;
